import { combineReducers } from "redux";
import { SET_USER_UID } from "../actions/types.js";
// User reducer with explicit typings
const userReducer = (state = null, action) => {
    switch (action.type) {
        case SET_USER_UID:
            return action.payload ?? null;
        default:
            return state;
    }
};
// Combine reducers into root reducer
const rootReducer = combineReducers({
    user: userReducer,
});
export default rootReducer;
